import { Component, OnInit, Output, EventEmitter, Input, ChangeDetectorRef } from '@angular/core';
import { NgForm, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import * as moment from 'moment';

import { TeemappService } from '@teem/services/teemapp.service';
import { LoaderService } from '@teem/services/loader.service';
import { SharedDataService } from '@teem/services/shared-data.service';
import { UserService } from '@teem/services/user.service';
import { messages as i18n } from '@teem/constants/messages';
import { country as CountryApi } from '@teem/constants/api';
import { CountryService } from '@teem/services/country.service';
import { TapContractModalComponent } from '@teem/setting-module/modals/tap-contract-modal/tap-contract-modal.component';
import { HyperpaySubscriptionModalComponent } from '@teem/setting-module/modals/hyperpay-subscription-modal/hyperpay-subscription-modal.component';
import { TeemContractModalComponent } from '@teem/app/features/setting/modals/teem-contract-modal/teem-contract-modal.component';
import { HIDE_PAYMENT_DATE } from '@teem/constants/defaults';
import * as RegexPattern from '@teem/constants/regex-patterns';
import { environment } from '@teem/environments/environment';
import { MyfatoorahContractModalComponent } from '../../../modals/myfatoorah-contract-modal/myfatoorah-contract-modal.component';

declare var $;

@Component({
  selector: 'myfatoorah-tab',
  templateUrl: './myfatoorah-tab.component.html',
  styleUrls: ['./myfatoorah-tab.component.scss']
})
export class MyfatoorahTabComponent implements OnInit {

  @Output() public updateUserDetails = new EventEmitter();
  @Output() public goToPlan = new EventEmitter();

  submitted: boolean = false;
  userDetails: any = null;
  bankListApi: string = CountryApi.myfatoorah_banks;
  banks: any = [];
  formSubmit: boolean = false;
  myfatoorahForm: any = {};
  myfatoorahFormGroup: FormGroup;
  labelStatus: string = 'default_show';
  selectedBank: any;
  fileCommercialDocument: File = null;
  fileOnwersIdDocument: File = null;
  fileIbanCertificateDocument: File = null;
  fileArticalAssociationDocument: File = null;
  fileUrlDocument: File = null;
  fileAllCivilIdsDocument: File = null;
  fileNationalAddressDocument: File = null;
  contractSign: boolean = false;
  hasFreelanceIdError = false;

  @Input("userDetails")
  set getInfo(val: any) {
    this.userDetails = val;
    this.myfatoorahForm = Object.assign({}, val);
    console.log(this.userDetails)

    // this.myfatoorahForm.myfatoorah_info.url_document_url = null;
    // this.myfatoorahForm.myfatoorah_info.commercial_document_url = null;
    // this.myfatoorahForm.myfatoorah_info.owners_id_url = null;
    // this.myfatoorahForm.myfatoorah_info.iban_certificate_url = null;
    // this.myfatoorahForm.myfatoorah_info.artical_association_url = null;

    if (this.userDetails?.subscription.subscription_status == 'free') {
      this.labelStatus = 'free_user';
    } else {
      this.labelStatus = 'paid_user';
    }
    
  }

  constructor(
    private loaderService: LoaderService,
    private userService: UserService,
    private teemappService: TeemappService,
    private sharedDataService: SharedDataService,
    private modalService: NgbModal,
    private countryService: CountryService,
    private cdr: ChangeDetectorRef, 
    private fb: FormBuilder
  ) {

  }

  ngOnInit(): void {
    this.initMyfatoorahForm();
  }

  initMyfatoorahForm() {
    this.myfatoorahFormGroup = this.fb.group({
      bank_id: [this.myfatoorahForm.myfatoorah_info.bank_id, [Validators.required]],
      bank_holder_name: [this.myfatoorahForm.myfatoorah_info.bank_holder_name, [Validators.required]],
      bank_account: [this.myfatoorahForm.myfatoorah_info.bank_account, [Validators.required, Validators.pattern(RegexPattern.english_string)]],
      iban: [this.myfatoorahForm.myfatoorah_info.iban, [Validators.required, Validators.pattern(RegexPattern.english_string)]],
      url_type:[this.myfatoorahForm.myfatoorah_info.url_type, [Validators.required]],
      document_url: [this.myfatoorahForm?.myfatoorah_info.document_url, [Validators.required, Validators.pattern(RegexPattern.url)]],
      url_document_url: [this.myfatoorahForm?.myfatoorah_info.url_document_url,],
      commercial_document_url: [this.myfatoorahForm?.myfatoorah_info.commercial_document_url,],
      owners_id_url: [this.myfatoorahForm?.myfatoorah_info.owners_id_url,],
      iban_certificate_url: [this.myfatoorahForm?.myfatoorah_info.iban_certificate_url,],
      artical_association_url: [this.myfatoorahForm?.myfatoorah_info.artical_association_url,],
      all_civil_id_url: [this.myfatoorahForm?.myfatoorah_info.all_civil_id_url,],
      national_address_url: [this.myfatoorahForm?.myfatoorah_info.national_address_url,],
      description:[this.myfatoorahForm?.myfatoorah_info.description,],
      trade_name: [this.myfatoorahForm?.myfatoorah_info.trade_name, [Validators.required]],
      store_name: [this.myfatoorahForm?.myfatoorah_info.store_name ?? this.userDetails?.business_name, [Validators.required]],
      cr_number: [this.myfatoorahForm?.myfatoorah_info.cr_number, [Validators.required]],
      identification_number: [this.myfatoorahForm?.myfatoorah_info.identification_number, [Validators.required]],
      manager_name: [this.myfatoorahForm?.myfatoorah_info.manager_name, [Validators.required]],
      invoice_email: [this.myfatoorahForm?.myfatoorah_info.invoice_email, [Validators.required]],
      address: [this.myfatoorahForm?.myfatoorah_info.address, [Validators.required]],
    });

    if (this.myfatoorahForm?.myfatoorah_info.bank_id) {
      this.selectedBank = {
        id: this.myfatoorahForm?.myfatoorah_info.bank_id,
        name: this.myfatoorahForm?.myfatoorah_info.bank_name
      }
    }

    setTimeout(() => {
      $('select[nice-select]').niceSelect('update');
    }, 500);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $('select[nice-select]').niceSelect('update');
    }, 300);
  }

  onChangeDocument(event, type) {
    if (type == 'url_document_url') {
      this.fileUrlDocument = event.target.files[0];
      let filename = this.fileUrlDocument.name;
      $('#file-upload_url_document').prev('label').text(filename);
    } else if (type == 'commercial_document_url') {
      this.fileCommercialDocument = event.target.files[0];
      let filename = this.fileCommercialDocument.name;
      $('#file-upload_commercial_document').prev('label').text(filename);
    } else if (type == 'iban_certificate_url') {
      this.fileIbanCertificateDocument = event.target.files[0];
      let filename = this.fileIbanCertificateDocument.name;
      $('#file-upload_iban_certificate').prev('label').text(filename);
    } else if (type == 'artical_association_url') {
      this.fileArticalAssociationDocument = event.target.files[0];
      let filename = this.fileArticalAssociationDocument.name;
      $('#file-upload_artical_association').prev('label').text(filename);
    } else if (type == 'owners_id_url') {
      this.fileOnwersIdDocument = event.target.files[0];
      let filename = this.fileOnwersIdDocument.name;
      $('#file-upload_owners_id').prev('label').text(filename);
    } else if (type == 'all_civil_id_url') {
      this.fileAllCivilIdsDocument = event.target.files[0];
      let filename = this.fileAllCivilIdsDocument.name;
      $('#file-upload_civil_ids_all_owners').prev('label').text(filename);
    } else if (type == 'national_address_url') {
      this.fileNationalAddressDocument = event.target.files[0];
      let filename = this.fileNationalAddressDocument.name;
      $('#file-upload_national_address_url').prev('label').text(filename);
    }
  }

  onBankSelected(bank: any) {
    this.selectedBank = {
      id: bank?.id,
      name: bank?.text
    }
  }

  editForm() {
    this.loaderService.startLoading();
    setTimeout(() => {
      this.loaderService.stopLoading();
      this.userDetails.is_myfatoorah_info = false;
    }, 100);
  }

  validateFile(){
    // if (this.myfatoorahForm?.myfatoorah_info.url_document_url  == null && this.myfatoorahForm?.myfatoorah_info.url_document_name == null) {
    //   this.myfatoorahFormGroup.controls.url_document_url.setValidators(Validators.required);
    //   this.myfatoorahFormGroup.controls.url_document_url.updateValueAndValidity();
    // }

    if (this.myfatoorahForm?.myfatoorah_info.commercial_document_url  == null && this.myfatoorahForm?.myfatoorah_info.commercial_document_name == null) {
      this.myfatoorahFormGroup.controls.commercial_document_url.setValidators(Validators.required);
      this.myfatoorahFormGroup.controls.commercial_document_url.updateValueAndValidity();
    }

    if (this.myfatoorahForm?.myfatoorah_info.owners_id_url  == null && this.myfatoorahForm?.myfatoorah_info.owners_id_name == null) {
      this.myfatoorahFormGroup.controls.owners_id_url.setValidators(Validators.required);
      this.myfatoorahFormGroup.controls.owners_id_url.updateValueAndValidity();
    }

    if (this.myfatoorahForm?.myfatoorah_info.iban_certificate_url  == null && this.myfatoorahForm?.myfatoorah_info.iban_certificate_name == null) {
      this.myfatoorahFormGroup.controls.iban_certificate_url.setValidators(Validators.required);
      this.myfatoorahFormGroup.controls.iban_certificate_url.updateValueAndValidity();
    }

    // if (this.myfatoorahForm?.myfatoorah_info.all_civil_id_url  == null && this.myfatoorahForm?.myfatoorah_info.all_civil_id_name == null) {
    //   this.myfatoorahFormGroup.controls.all_civil_id_url.setValidators(Validators.required);
    //   this.myfatoorahFormGroup.controls.all_civil_id_url.updateValueAndValidity();
    // }

  }

  onSubmit() {
    this.validateFile();
    this.formSubmit = true;
    if (this.myfatoorahFormGroup.valid) {
      this.loaderService.startLoading();
      let fd = this.myfatoorahFormGroup.value;

      if (this.fileUrlDocument) fd.url_document_url = this.fileUrlDocument;
      if (this.fileCommercialDocument) fd.commercial_document_url = this.fileCommercialDocument;
      if (this.fileOnwersIdDocument) fd.owners_id_url = this.fileOnwersIdDocument;
      if (this.fileAllCivilIdsDocument) fd.all_civil_id_url = this.fileAllCivilIdsDocument;
      if (this.fileNationalAddressDocument) fd.national_address_url = this.fileNationalAddressDocument;
      if (this.fileIbanCertificateDocument) fd.iban_certificate_url = this.fileIbanCertificateDocument;
      if (this.fileArticalAssociationDocument) fd.artical_association_url = this.fileArticalAssociationDocument;

      this.userService.storeMyfatoorah(fd, { headers: { 'Content-Type': 'multipart/form-data' } }).subscribe(
        (res: any) => {
          this.loaderService.stopLoading();
          this.myfatoorahForm = Object.assign({}, res.user);
          // Update app basic info for user
          let userInfo = this.sharedDataService.getItem('userInfo');
          if (userInfo != undefined) {
            Object.assign(userInfo, res.user);
            Object.assign(this.userDetails, res.user);
            this.sharedDataService.setItem('userInfo', userInfo);
          }
          Swal.fire(
            i18n.hyperpay.your_request_has_been_sent,
            i18n.hyperpay.thank_you_for_entering_your_application,
            'success'
          );
        },
        (err) => {
          this.loaderService.stopLoading();
          if (err.status === 403) {
            console.log(err.error.errors);
            if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
              let validationErrors = err.error.errors;
              // let serverError = [];
              // // Object.keys(validationErrors).forEach((prop) => {
              // //   if (validationErrors[prop]['message']) {
              // //     serverError.push(validationErrors[prop]['message']);
              // //   } else if (validationErrors[prop]['description']) {
              // //     serverError.push(validationErrors[prop]['description']);
              // //   }
              // // })
              Swal.fire(i18n.alert.error, JSON.stringify(validationErrors), 'error');
            }
          } else if (err.status === 422) {
            if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
              let validationErrors = err.error.errors;
              Object.keys(validationErrors).forEach((prop) => {
                this.myfatoorahFormGroup.controls[prop]?.setErrors({
                  serverError: validationErrors[prop]
                });
              })
            }
          } else {
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
          }
        }
      );
    }
  }

  updateStatus(uuid, event: any) {
    console.log(event);
    let checked = event.target.checked;
    this.userDetails.myfatoorah_info.is_enable = !checked;
    Swal.fire({
      title: i18n.are_you_sure,
      text: i18n.you_want_to_update_status,
      icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: i18n.yes,
      cancelButtonText: i18n.no_cancel_it
    }).then(result => {
      if (result.value) {
        let fd: any = {};
        fd.uuid = uuid;
        fd.type = 'myfatoorah';
        this.loaderService.startLoading();
        this.userService.updateStatus(fd).subscribe((data: any) => {
          this.loaderService.stopLoading();
          event.target.checked = checked;
          this.userDetails.myfatoorah_info.is_enable = !checked;
          setTimeout(function () {
            Swal.fire(i18n.done, i18n.status_updated_successfully, 'success');
          }, 0);

        }, err => {
          this.loaderService.stopLoading();
          event.target.checked = !checked;
          this.userDetails.myfatoorah_info.is_enable = checked;
          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        })
      }else{
        event.target.checked = !checked;
        this.userDetails.myfatoorah_info.is_enable = checked;
        return false;
      }
    });
  }

  downloadPdf() {
    if ((window as any).LOCALE == 'ar') {
      (window as any).open(`${environment.baseUrl}/images/pdf/pdf-tap-online-payments-arabic.pdf`, '_blank', 'location=yes');
    } else {
      (window as any).open(`${environment.baseUrl}/images/pdf/pdf-tap-online-payments-english.pdf`, '_blank', 'location=yes');
    }
  }

  onSignContract() {
    this.validateFile();
    this.formSubmit = true;
    if (this.myfatoorahFormGroup.valid && !this.hasFreelanceIdError) {
      let myfatoorahFormData = this.myfatoorahFormGroup.value;
      myfatoorahFormData.bank_name = this.selectedBank?.name;

      // const modalRef = this.modalService.open(MyfatoorahContractModalComponent);
      const modalRef = this.modalService.open(TeemContractModalComponent);
      modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.id = "fatoorahcontract";
      modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.classList.add('fatoorah-contract1');
      // Set id on modal dialog
      modalRef.componentInstance.userDetails = this.userDetails;
      modalRef.componentInstance.contractFromData = myfatoorahFormData;
      modalRef.componentInstance.paymentGateWay = 'myfatoorah';
      modalRef.componentInstance.bankName = this.selectedBank?.name;

      modalRef.result.then(result => {
        this.contractSign = true;
        this.userDetails.is_myfatoorah_info = false;
        this.onSubmit();
      }, fallbackResult => {
        // do nothing
        this.contractSign = false;
      })
    }
  }

  goBack() {
    this.userDetails.is_myfatoorah_info = true;
  }

  ngOnDestroy(): void {
    this.userDetails.is_myfatoorah_info = true;
  }



  
}
